
import * as CustomerModels from '../../models/customer/customer';
import * as Models from "../../models/commonModels";

export class GetCustomerDictionary {
  static readonly type = '[Customer] GetCustomerDictionary';
  constructor(public OnlyMy: boolean = false, public ShowExternalCustomers: boolean = false, public OnlyActive: boolean = false) { }
}

export class GetCustomerAvailableForServiceDictionary {
  static readonly type = '[Customer] GetCustomerAvailableForServiceDictionary';
  constructor(public OnlyMy: boolean = false, public ShowExternalCustomers: boolean = false, public OnlyActive: boolean = false) { }
}

export class GetDisactiveCustomerDictionary {
  static readonly type = '[Customer] GetDisactiveCustomerDictionary';
  constructor() { }
}

export class GetCustomersUserList {
  static readonly type = '[Customer] GetCustomersUserList';
  constructor(public CustomerId: number) { }
}

export class GetSubcompanies {
  static readonly type = '[Customer] GetSubcompanies';
  constructor() { }
}

export class GetContractStatus {
  static readonly type = '[Customer] GetContractStatus';
  constructor() { }
}

export class GetList {
  static readonly type = "[Customer] GetList";
  constructor(public Search: CustomerModels.CustomerSearchModel) { }
}

export class GetParentChildList {
  static readonly type = "[Customer] GetParentChildList";
  constructor(public Search: CustomerModels.CustomerSearchModel) { }
}

export class SetCustomerSearch {
  static readonly type = "[Customer] SetCustomerSearch";
  constructor(public Search: CustomerModels.CustomerSearchModel) { }
}

export class SetCustomerListPage {
  static readonly type = "[Customer] SetCustomerListPage";
  constructor(public Search: CustomerModels.CustomerSearchModel) { }
}

export class ResetCustomerSearch {
  static readonly type = "[Customer] ResetCustomerSearch";
  constructor() { }
}

export class GetSelectedCustomers {
  static readonly type = "[Customer] GetSelectedCustomers";
  constructor() { }
}

export class SetSelectedCustomers {
  static readonly type = "[Customer] SetSelectedCustomers";
  constructor(public Customers: CustomerModels.CustomerPreviewModel[]) { }
}

export class Set {
  static readonly type = "[Customer] Set";
  constructor(public Customers: Models.Request<CustomerModels.CustomerModel>) { }
}

export class Remove {
  static readonly type = "[Customer] Remove";
  constructor(public Customers: Models.Request<CustomerModels.CustomerModel>) { }
}

export class SetActive {
  static readonly type = "[Customer] Set Active";
  constructor(public Customers: Models.Request<CustomerModels.CustomerModel>) { }
}

export class Create {
  static readonly type = "[Customer] Create";
  constructor(public Customers: Models.Request<CustomerModels.CustomerModel>) { }
}

export class Get {
  static readonly type = "[Customer] Get";
  constructor(public Customers: Models.RequestModel) { }
}

export class GetGarages {
  static readonly type = "[Customer] Get garages";
  constructor(public Customer: Models.RequestModel) { }
}

export class LinkGarage {
  static readonly type = "[Customer] Link Garage";
  constructor(public Link: Models.Request<CustomerModels.CustomerGarageModel>) { }
}

export class LinkAllGarage {
  static readonly type = "[Customer] Link All Garage";
  constructor(public Link: Models.Request<CustomerModels.CustomerGarageModel[]>) { }
}

export class GetCustomerChildListExcel {
  static readonly type = "[Customer] Get Customer Child List Excel Report";
  constructor(public ReportName: string, public Search: CustomerModels.CustomerSearchModel) { }
}

export class GetService {
  static readonly type = "[Customer] Get Service";
  constructor(public Customer: Models.RequestModel) { }
}

export class LinkService {
  static readonly type = "[Customer] Link Service";
  constructor(public Link: Models.Request<CustomerModels.CustomerServiceModel[]>) { }
}


export class GetAPICustomerServiceRights {
  static readonly type = "[Customer] Get APICustomerServiceRights";
  constructor(public Customer: Models.RequestModel) { }
}


export class SetAPICustomerServiceRights {
  static readonly type = "[Customer] Set APICustomerServiceRights";
  constructor(public APICustomerServiceRight: Models.Request<CustomerModels.APICustomerServiceRightsModel>) { }
}
